/* ==========================================================================
   AMADA THE FABRIC GUIDE — chips 页内定位 / scrollspy
   --------------------------------------------------------------------------
   终稿在同一页面连续展示 PERFORMANCE / LINEN / COTTON 三组，不能隐藏未选组。
   点击有内容的 chip 平滑滚动到分组；scrollspy 只更新黑底选中态。

   心形收藏 / 加购：本文件不涉及。收藏走全站 amada-favorites.js 的
   document 级 [data-favorites-toggle] 委托，本轮不做加购（用户 2026-08-26 明确要求）。
   ========================================================================== */
(function () {
  'use strict';

  function initFabricGuide(root) {
    var chips = root.querySelectorAll('[data-fabric-chip]');
    var groups = root.querySelectorAll('[data-fabric-group]');
    if (!chips.length || !groups.length) return;

    function activate(groupId) {
      for (var i = 0; i < chips.length; i++) {
        var chip = chips[i];
        var isActive = chip.getAttribute('data-group') === groupId;
        chip.classList.toggle('is-active', isActive);
        chip.setAttribute('aria-selected', isActive ? 'true' : 'false');
      }
    }

    for (var i = 0; i < chips.length; i++) {
      (function (chip) {
        chip.addEventListener('click', function () {
          // N-1：终稿只画了 PERFORMANCE / LINEN / COTTON 三个内容段，
          // LEATHER & SUEDE / RAFFIA 没有对应分组。原来点这两枚 chip 会把它涂黑
          // 但页面毫无变化（target 为 null 静默返回）——制造「选中了一个空分类」的假象。
          // 现在直接不响应，选中态仍留在当前有内容的分组上。最终口径待拍板，见报告。
          if (chip.getAttribute('aria-disabled') === 'true') return;
          var groupId = chip.getAttribute('data-group');
          var target = root.querySelector('[data-fabric-group="' + groupId + '"]');
          if (!target) return;
          activate(groupId);
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      })(chips[i]);
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        var visible = entries.filter(function (entry) { return entry.isIntersecting; });
        if (!visible.length) return;
        visible.sort(function (a, b) { return a.boundingClientRect.top - b.boundingClientRect.top; });
        activate(visible[0].target.getAttribute('data-fabric-group'));
      }, { rootMargin: '-20% 0px -65% 0px', threshold: 0 });
      for (var j = 0; j < groups.length; j++) observer.observe(groups[j]);
    }
  }

  var roots = document.querySelectorAll('[data-fabric-guide]');
  for (var i = 0; i < roots.length; i++) {
    initFabricGuide(roots[i]);
  }
})();
